import { render, staticRenderFns } from "./GroupCertificate.vue?vue&type=template&id=006410b5&scoped=true"
import script from "./GroupCertificate.vue?vue&type=script&lang=js"
export * from "./GroupCertificate.vue?vue&type=script&lang=js"
import style0 from "./GroupCertificate.scss?vue&type=style&index=0&id=006410b5&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006410b5",
  null
  
)

export default component.exports